<template>
  <div class="dark">
        <InsideBanner />
		<h1 class="inside_page_name">Oh No!</h1>
  <div class="container error">

    <h1><i class="fas fa-1x fa-exclamation-triangle"></i>404 or 405 . . . or whatever!<i class="fas fa-1x fa-exclamation-triangle"></i></h1>
    <h2>Epitome.exe has stopped working!</h2>
    <h2>Let's just stay calm, Dude.</h2>
    <router-link class="safety" to="/"><i class="fa fa-1x fa-ambulance" aria-hidden="true"></i>Flee to Safety!<i class="fa fa-1x fa-ambulance" aria-hidden="true"></i></router-link>
    <img src="@/assets/img/sara_error.png" alt="sara attacks">
  </div>
  </div>
</template>

<script>
import InsideBanner from "@/components/InsideBanner.vue";
export default {
        components: {
        InsideBanner
      },
}
</script>
